import React from 'react';
import loaderSvg from '@/assets/Loader.svg';

interface LoadingScreenProps {
  message?: string;
  className?: string;
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message,
  className = '',
  fullScreen = true,
}) => {
  const isRateList = typeof window !== 'undefined' && (
    window.location.pathname.startsWith('/rates') ||
    window.location.pathname.startsWith('/rate-list') ||
    window.location.pathname.startsWith('/ratelist') ||
    window.location.pathname.startsWith('/r/') ||
    window.location.pathname === '/r'
  );

  const displayMessage = isRateList
    ? (message === 'Loading UNIBMS…' || !message ? 'loading UNIBMS Rate List' : message)
    : (message !== undefined ? message : 'Loading UNIBMS…');

  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen
          ? 'fixed inset-0 z-50 min-h-screen bg-gray-50/90 backdrop-blur-xs p-4'
          : 'w-full h-full min-h-[380px] flex-1 bg-transparent p-6'
      } ${className}`}
    >
      <div className="flex flex-col items-center gap-2.5 animate-fade-in text-center max-w-xs">
        <div className="w-40 sm:w-48 h-auto flex items-center justify-center">
          <img
            src={loaderSvg}
            alt="Loading..."
            className="w-full h-auto object-contain pointer-events-none select-none drop-shadow-sm"
          />
        </div>
        {displayMessage && (
          <p className="text-sm font-semibold text-gray-600 tracking-tight mt-1 animate-pulse">
            {displayMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;

